import Typography from '~/shared/components/Typography';

interface AmPmToggleProps {
  /** `true` = PM, `false` = AM */
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function AmPmToggle({ value, onChange }: AmPmToggleProps) {
  return (
    <div className="relative inline-flex h-9 w-24 items-center rounded-[8px] border border-gray-300 bg-white p-1">
      <div
        className={`absolute h-8 w-11 rounded-[7px] bg-[#0D2062] shadow transition-transform duration-300 ease-in-out ${!value ? 'translate-x-0' : 'translate-x-full'}`}
      />
      <button
        type="button"
        aria-pressed={!value}
        className="z-10 w-1/2 cursor-pointer text-center"
        onClick={() => onChange(false)}
      >
        <Typography
          fontWeight={400}
          variant="p3"
          color={!value ? 'text-white' : 'text-primary-900'}
        >
          AM
        </Typography>
      </button>
      <button
        type="button"
        aria-pressed={value}
        className="z-10 w-1/2 cursor-pointer text-center"
        onClick={() => onChange(true)}
      >
        <Typography
          fontWeight={400}
          variant="p3"
          color={value ? 'text-white' : 'text-primary-900'}
        >
          PM
        </Typography>
      </button>
    </div>
  );
}
